import { FeaturedPostCard } from 'components/Blog'
import { useBlogPostsQuery } from 'hooks/useBlogPostsQuery'
import { ComponentType } from 'react'
import { Col, Row } from 'reactstrap'
import styled from 'styled-components'

const Title = styled.h2`
  margin-bottom: 24px;
  color: #ffffff;
  font-size: 26px;
  font-weight: bold;
  line-height: 33px;
  text-align: center;
`

const Subtitle = styled.p`
  margin-bottom: 48px;
  color: #6bc0f9;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
`

const BlogText = styled.p`
  margin-bottom: 24px;
  color: #6bc0f9;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
`

const Schedule = styled.div`
  padding: 74px 0 0;
`

const ScheduleTitle = styled.h6`
  margin-bottom: 12px;
  color: #6bc0f9;
  font-size: 15px;
  font-weight: bold;
  line-height: 23px;
`

const ScheduleText = styled.p`
  margin: 0;
  opacity: 0.5;
  color: #6bc0f9;
  font-size: 15px;
  line-height: 23px;
`

export const Thanks: ComponentType = () => {
  const { data } = useBlogPostsQuery({
    variables: { query: { limit: 1 } },
  })

  const [post] = data?.blogPosts.posts ?? []

  return (
    <div>
      <Title>Gracias por tu interés</Title>
      <Subtitle>Hemos recibido tu solicitud. Un Asesor Certificado te estará contactando en breve.</Subtitle>
      <BlogText>Te invitamos a leer este post destacado en nuestro blog:</BlogText>
      {post && <FeaturedPostCard post={post} />}
      <Row className="justify-content-center">
        <Col md={8}>
          <Schedule>
            <ScheduleTitle>Horario de oficina</ScheduleTitle>
            <ScheduleText>
              Nuestros Asesores Certificado están disponibles de lunes a sábado de 8:00 am a 7:30 pm.
            </ScheduleText>
          </Schedule>
        </Col>
      </Row>
    </div>
  )
}
